import "video-react/dist/video-react.css";
import "./CustomPlayer.css";

import { ControlBar, Player } from "video-react";
import { useEffect, useRef } from "react";

function SyncVideoPlayer({ videoUrls, width = "100%", height = "50%" }) {
  if (videoUrls.length > 4) videoUrls.slice(0, 4);

  const gridSize = videoUrls.length === 1 ? 1 : 2;

  const mainPlayerRef = useRef(null);
  const subPlayerRefs = [useRef(null), useRef(null), useRef(null)];
  const containerRef = useRef(null);

  const setControlBar = async () => {
    const container = containerRef.current;
    if (!container) return;
    const parentHeight = await container.offsetHeight;
    const innerVideo = container.querySelector(".video-react-controls-enabled");
    if (!innerVideo) return;
    console.log("innerVideo: ", innerVideo);
    const innerVideoHeight = await innerVideo.offsetHeight;
    const controlBar = container.querySelector(".video-react-control-bar");
    if (controlBar) {
      console.log("container: ", container);
      console.log("parentHeight: ", parentHeight);
      controlBar.style.top = `calc(${parentHeight + innerVideoHeight + (parentHeight - innerVideoHeight) / 2}px`;
    }
    return;
  };

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          setControlBar();
        }
      });
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    // 清理 observer
    return () => observer.disconnect();
  }, [containerRef.current, videoUrls]);

  const renderControls = function (index) {
    if (index === 0) {
      return <ControlBar autoHide={false}></ControlBar>;
    }
    return <ControlBar disabled></ControlBar>;
  };

  const handlePlay = () => {
    console.log("handlePlay");
    subPlayerRefs.forEach((playerRef) => {
      const player = playerRef.current;
      if (player) {
        player.play();
      }
    });
  };

  const handlePause = () => {
    console.log("handlePause");
    subPlayerRefs.forEach((playerRef) => {
      const player = playerRef.current;
      if (player) {
        player.pause();
      }
    });
  };

  const handleSeek = () => {
    console.log("handleSeek");
    const currentTime = mainPlayerRef.current.getState().player.currentTime;
    subPlayerRefs.forEach((playerRef) => {
      const player = playerRef.current;
      if (player) {
        player.seek(currentTime);
      }
    });
  };

  const handleVolumeChange = () => {
    console.log("handleVolumeChange");
    const volume = mainPlayerRef.current.getState().player.volume;
    subPlayerRefs.forEach((playerRef) => {
      const player = playerRef.current;
      if (player) {
        player.volume = volume;
      }
    });
  };

  useEffect(() => {
    const mainPlayer = mainPlayerRef.current;
    if (
      !mainPlayer ||
      subPlayerRefs.every((playerRef) => playerRef.current === null)
    ) {
      return;
    }

    const paused = mainPlayer.getState().player.paused;
    const currentTime = mainPlayer.getState().player.currentTime;
    const volume = mainPlayer.getState().player.volume;

    subPlayerRefs.forEach((playerRef) => {
      const player = playerRef.current;
      if (player) {
        player.pause();
        player.volume = volume;
        player.seek(currentTime);
        if (!paused) {
          player.play();
        }
      }
    });
  }, [subPlayerRefs]);

  return (
    <div>
      <div
        style={{
          position: "relative",
          width: width,
          height: height,
          marginBottom: "3em",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(${gridSize}, 1fr)`,
            gridTemplateRows: `repeat(${gridSize}, 1fr)`,
            gap: "1px",
            width: width,
            height: height,
            marginBottom: "3em",
          }}
        >
          {videoUrls.length &&
            videoUrls.map((videoUrl, index) => (
              <div
                key={index}
                ref={index == 0 ? containerRef : null}
                className={"player-box"}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "black",
                }}
              >
                {/*<video src={videoUrl} style={{width: "100%", height: "100%"}} controls muted autoPlay></video>*/}
                <Player
                  ref={index === 0 ? mainPlayerRef : subPlayerRefs[index - 1]}
                  src={videoUrl}
                  autoPlay
                  onPlay={index === 0 ? handlePlay : null}
                  onPause={index === 0 ? handlePause : null}
                  onSeeked={index === 0 ? handleSeek : null}
                  onVolumeChange={index === 0 ? handleVolumeChange : null}
                >
                  <source src={videoUrl} />
                  {renderControls(index)}
                </Player>
              </div>
            ))}
          {Array.from({ length: gridSize * gridSize - videoUrls.length }).map(
            (_, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%",
                  backgroundColor: "black",
                  color: "white",
                  fontSize: "5rem",
                  border: "3px solid white",
                }}
              >
                ⨉
              </div>
            ),
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: width,
            height: height,
            backgroundColor: "rgba(0, 0, 0, 0)",
            zIndex: 1,
          }}
        ></div>
      </div>
    </div>
  );
}

export default SyncVideoPlayer;
